import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { LogoMark, useToast } from '../../components/ui';
import { useMe } from '../../lib/queries';
import { HomeHero } from './HomeHero';
import styles from './HomePage.module.css';

const FEATURES = [
  { n: '01', title: 'Академия', text: 'Своя школа с названием и адресом: на нём открываются лендинги курсов.' },
  { n: '02', title: 'Курсы', text: 'Разделы и уроки: видео с YouTube и текст к нему.' },
  { n: '03', title: 'Студенты', text: 'Приглашения по email и промокоды с ограниченным сроком.' },
];

export function HomePage() {
  const { data: author } = useMe();
  const [params, setParams] = useSearchParams();
  const toast = useToast();

  useEffect(() => {
    document.title = 'zerno — платформа онлайн-курсов';
  }, []);

  // One-time student links that were already used land here.
  useEffect(() => {
    if (params.get('link') !== 'expired') return;
    toast('Ссылка для входа устарела — запросите новую на странице курса');
    setParams({}, { replace: true });
  }, [params, setParams, toast]);

  return (
    <div className={styles.page}>
      <HomeHero signedIn={Boolean(author)} />
      <section className={styles.features}>
        {FEATURES.map((f) => (
          <div key={f.n} className={styles.card}>
            <span className={styles.n}>{f.n}</span>
            <span className={styles.cardTitle}>{f.title}</span>
            <span className={styles.cardText}>{f.text}</span>
          </div>
        ))}
      </section>
      <footer className={styles.footer}>
        <span className={styles.made}>
          <LogoMark size={18} strokeWidth={5} />
          zerno · {new Date().getFullYear()}
        </span>
      </footer>
    </div>
  );
}
